import { Button } from 'devextreme-react';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import './PopupInformation.scss';
import { ReactNode } from 'react';

interface PopupInformationProps {
  children: ReactNode;
  handleClose: () => void;
  width?: number;
  height?: number;
  visible: boolean;
  title: string;
}

export const PopupInformation: React.FC<PopupInformationProps> = ({ children, handleClose, width = 500, height, visible, title }) => {
  const { isXSmall } = useScreenSize();
  return (
    <Popup height={height || 'auto'} title={title} onHiding={handleClose} fullScreen={isXSmall} hideOnOutsideClick={true} width={width} showCloseButton visible={visible} dragEnabled={false} showTitle={true}>
      {children}
      <ToolbarItem toolbar='bottom' location='after'>
        <div className={`form-popup-buttons-container ${width <= 360 ? 'flex-buttons' : ''}`}>
          <Button text='Aceptar' stylingMode='contained' type='default' onClick={handleClose} />
        </div>
      </ToolbarItem>
    </Popup>
  );
};
